import { Component, HostListener, OnInit } from '@angular/core';
import { ErrorService, LeadService } from '@gen/shared';
import { SellerModel } from 'libs/shared/src/lib/models/sellers/sellers.model';
import { StateManagementService } from 'libs/shared/src/lib/state-management/state-management.service';
import { Message } from 'libs/shared/src/lib/utils/message';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss'],
})
export class BrandsComponent implements OnInit {
  public sellers: Array<SellerModel> = [];

  public loading: boolean = true;
  public isMobile: boolean = window.innerWidth < 768;

  private destroy$ = new Subject();

  constructor(
    private $lead: LeadService,
    private $error: ErrorService,
    private $notification: StateManagementService
  ) {}

  public ngOnInit(): void {
    this.setTitle();
    this.getSellers();
  }

  private setTitle(): void {
    this.$notification.setTitle('Marcas');
  }

  private getSellers(): void {
    this.$lead
      .getAllSellers()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res?.data?.allSellersCoupon) {
            this.sellers = JSON.parse(JSON.stringify(res.data.allSellersCoupon));

            this.sellers = this.sellers.map((option) => {
              let nameArray: string[] = option.business_name.split(' ');
              option.business_name = this.isMobile ? nameArray[0] : nameArray[0] + ' ' + nameArray[1];

              return option;
            });
          }

          setTimeout(() => {
            this.loading = false;
          }, 1500);
        },
        error: (error) => {
          this.loading = false;
          this.$error.errorHandling(error, Message.ERROR_CONECTION);
        },
      });
  }

  public goToProducts(typeFilter: 'sponsors' | 'category' | 'seller', entity: any): void {
    switch (typeFilter) {
      case 'sponsors':
        // to do
        break;
      case 'category':
        this.$notification.setChangedCategory(entity);
        break;
      case 'seller':
        this.$notification.setSeller(entity);
        break;
    }
  }
}
